module.exports = __webpack_public_path__ + "static/media/image_2.f8033755.png";